import { useEffect, useState } from "react";

const KEY = "rhf_reduced_motion";
const listeners = new Set();

const systemPrefers = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const getReducedMotion = () => {
  const v = localStorage.getItem(KEY);
  return v === null ? !!systemPrefers() : v === "1";
};

export const setReducedMotion = (on) => {
  localStorage.setItem(KEY, on ? "1" : "0");
  document.documentElement.classList.toggle("reduce-motion", on);
  listeners.forEach((l) => l(on));
};

export const useReducedMotion = () => {
  const [on, setOn] = useState(getReducedMotion);
  useEffect(() => {
    document.documentElement.classList.toggle("reduce-motion", on);
    listeners.add(setOn);
    return () => listeners.delete(setOn);
  }, [on]);
  return on;
};
